module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n      Editar Email - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n      Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v(_vm._s(_vm.email_current.user_created_name) + " -\n        " + _vm._s(_vm.email_current.created_at) + "\n      ")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.name),
      expression: "email_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.number),
      expression: "email_current.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n            " + _vm._s(num) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.campaign_attribute.project_name),
      expression: "email_current.campaign_attribute.project_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.campaign_attribute.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current.campaign_attribute, "project_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.campaign_attribute.name),
      expression: "email_current.campaign_attribute.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.campaign_attribute.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current.campaign_attribute, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.date),
      expression: "email_current.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email_current.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Urgente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.urgent),
      expression: "email_current.urgent"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "urgent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("SI")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.state_id),
      expression: "email_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n            " + _vm._s(state.name) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Realizado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.user_id),
      expression: "email_current.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Revisado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.reviewed_by),
      expression: "email_current.reviewed_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "reviewed_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.email_current.path) ? _c('div', {
    staticClass: "relative col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.path),
      expression: "email_current.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email_current.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "path", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.email_current.path,
      "target": "_blank"
    }
  }, [(_vm.email_current.path) ? _c('div', {
    staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
  }, [_c('app-icon', {
    attrs: {
      "name": "link",
      "classname": "w-4 h-4"
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    [5, 7].includes(_vm.email_current.state_id) ||
    (_vm.email_current.state_id == 4 && _vm.usersession.team_id == 1)
  ) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.response_observations),
      expression: "email_current.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.email_current.response_observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "response_observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "relative col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2 relative"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (Opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.response_path),
      expression: "email_current.response_path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email_current.response_path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "response_path", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.email_current.response_path) ? _c('a', {
    staticClass: "courser-pointer",
    attrs: {
      "href": _vm.email_current.response_path,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
  }, [_c('app-icon', {
    attrs: {
      "name": "link",
      "classname": "w-4 h-4"
    }
  })], 1)]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeEditEmail')
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), (_vm.email_current.versions) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.email_current.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center gap-5 p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n        " + _vm._s(version.observations) + "\n        "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(version.created_at))]), _vm._v(" "), (version.path) ? _c('a', {
      staticClass: "button couser-pointer inline-block inline-flex bg-gray-200",
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1"
      }
    }), _vm._v("   Abrir Url\n        ")], 1) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n        " + _vm._s(version.response_observations) + "\n        "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(version.updated_at))]), _vm._v(" "), (version.response_path) ? _c('a', {
      staticClass: "button couser-pointer inline-block inline-flex bg-gray-200",
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1"
      }
    }), _vm._v("   Abrir Url\n        ")], 1) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6 mb-1"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('label', [_vm._v("Url Archivo (Opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 col-span-12 sm:col-span-12"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion",
        "disabled": _vm.buttonIsLoading
      }
    }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Responder ")]], 2)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-12 sm:col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "createversion",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Confirmar Nueva Version ")]], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbd6e08e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/EmailEditModal.vue
// module id = 474
// module chunks = 1